// extracted by mini-css-extract-plugin
export default {"section":"f55e7c3a333a","panelTrigger":"fa89f641ca47","expandCollapsePanel":"d355a7ffca10","content":"d8b3da5857bb"};